
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'department',
  setup() {
    return {}
  }
})
